export default {
	tenantId: "trinity_uat",
	appId: "covergo_crm",
	fileSystem: {
		bucketName: "trinity--uat"
	}
}
